import { render } from "./RefStatsChart.vue?vue&type=template&id=48fcb2a2"
import script from "./RefStatsChart.vue?vue&type=script&lang=js"
export * from "./RefStatsChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__